import React from "react";
import ChecksDoubleIconSVG from "assets/svg/checks-icons";
import NotificationContentItem from "./notification-content-item";
import { useNotifications } from "redux/modules/notification/hooks";
import _ from "lodash";
import NotificationEmpty from "assets/svg/notificationEmpty";
import { useHistory, useParams,useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { randomExtension } from "utils/utils";
import toast from "react-hot-toast";
import { useMilestones } from "redux/modules/milestone/hooks";


export default function NotificationContainer({
  acceptInvite = () => {},
  onMarkRead = () => {},
  onMarkReadNotification = () => {},
  getNotifications = () => {},
  setSelectedTab= ()=>{},
  isYourProfile,
  userData
}) {
  const { t } = useTranslation();
  const { notifications,setNotifications,notification_page_read,notificationPage, countUnread } = useNotifications();
  let hideRead = notifications;
  const {taggedMilestones,removeTaggedMilestones} = useMilestones();
  const { http } = global.services;

  const loc = useLocation();

  const history = useHistory();
  const { username, profileId } = useParams();

  const markRead = async () => {
    try{
      await onMarkRead();
    }catch(e){
      console.error(e)
    }
  };

  const markReadNotification = async (id) => {

    let notifications = notificationPage.map(item =>{
      if(item.id === id){
        return {
          ...item,
          is_read:true
        }
      }
      return item;
    });

    notification_page_read({
        data: notifications
    })
    
    await onMarkReadNotification(id);
  };

  const pushNotification = () => {
    history.push(`/${username}/profile/${profileId}/notification`);
  };

  const handleClick = (data = {}) => {
    console.log(data);
    const type = data.type;
    const { from } = data.user_access_notification || {};

    switch (type) {
      case "following":
        // removed and make name clicking makes it go to follower's page
        // gotoFollowersProfile(from); 
        return;
      case "new_milestone":
      case "mention_milestone":
          gotoMilestonePost(data);
        return;
      // case "profile_invite":
      //   acceptInvite(data);
      //   return;
      default:
        console.log("no match");
    }
  };

  const gotoFollowersProfile = (from) => {
    const followerURL = `/${encodeURIComponent(
      from?.username
    )}-${randomExtension()}/profile/${encodeURIComponent(from?.profile?.id)}`;
    console.log({ followerURL });
    history.push(followerURL);
  };

  const gotoMilestonePost = async(item) => {
    // todo: go to milestone post
    const {data} = await http.get(`public/milestone-tag/${item.milestone_id}/${item?.user_profile_id}`);
    if(!data){
      toast.error("This tagged milestone is no longer available.");
      const removedTag = taggedMilestones.filter(milestone => milestone.id !== item.milestone_id);
      removeTaggedMilestones({ data: removedTag, total: removedTag.length })
      return;
    }

    setSelectedTab("tagged");
    // const { from } = data.user_access_notification || {};
    if(isYourProfile){
      const milestoneId = item.milestone_id;
      //Direct to your own tagged tab
      // let followingURL = `/${encodeURIComponent(from?.username)}-${randomExtension()}/profile/${encodeURIComponent(data?.user_profile_id)}`;
      let pathWithoutSearch = loc.pathname;
      if(milestoneId) {
          pathWithoutSearch += `?focusMilestone=${encodeURIComponent(milestoneId)}`;
      }
      history.replace(pathWithoutSearch);
      return;
    }

    const milestoneId = item.milestone_id;
    //Direct to your own tagged tab
    let followingURL = `/${encodeURIComponent(userData.user?.username)}-${randomExtension()}/profile/${encodeURIComponent(item?.user_profile_id)}`;
    if(milestoneId) {
        followingURL += `?focusMilestone=${encodeURIComponent(milestoneId)}`;
    }
    history.replace(followingURL);
  };

  

  const removeFromList = async(e,id)=>{
    e.stopPropagation();
   try {
      setNotifications({notifications:notifications.filter((notif) => notif.id !== id)});
      notification_page_read({
        data: notificationPage.filter((notif) => notif.id !== id)
      })
      await http.put(`notifications/${id}/removed`);
      getNotifications();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div
      className="w-[370px] 2sm:w-419 notification-container"
      style={{ minHeight: 200 }}
    >
      <div className="w-full p-6">
        {/* header */}
        <div className="w--full flex justify-between items-center">
          <h1 className="text-lg font-semibold leading-5.5 text-lightBlack">
            <button onClick={pushNotification}>{t("notification")}</button>
          </h1>
          {/* {!_.isEmpty(hideRead) && hideRead.length >= 2 && ( */}
          {countUnread !== 0 && (
            <button
              onClick={markRead}
              className="text-base font-medium leading-4.9 text-primary flex items-center"
            >
              <ChecksDoubleIconSVG className="mr-2" />
              {t("markAllAsRead")}
            </button>
          )}
        </div>
        {/* end header */}
        {/* content */}
        <div className="w-full mt-8">
          {!_.isEmpty(notifications) ? (
            <>
              {!_.isEmpty(hideRead) ? (
                <ul className="w-full grid gap-y-4">
                  {hideRead.map((obj, index) => (
                    <>
                      {console.log("::NOTIF", obj)}
                      <NotificationContentItem
                        key={index}
                        {...obj}
                        acceptInvite={() => acceptInvite(obj)}
                        markReadNotification={(e,id) => {
                          handleClick(obj);
                          markReadNotification(id);
                        }}
                        onFollowerNameClick={() => gotoFollowersProfile(obj.user_access_notification?.from)}
                        removeFromList={removeFromList}
                        profile = {userData?.profile}
                      />
                    </>
                  ))}
                </ul>
              ) : (
                <div className="text-center">
                  <div className="flex justifya-center items-center flex-col">
                    <div>
                      <NotificationEmpty />
                    </div>
                    <div className="font-bold text-lg mt-4">
                      {t("noNotifications")}
                    </div>
                    <div className="text-xs mt-1">
                      {t("thereIsNoNotification")}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="text-center">
              <div className="flex justifya-center items-center flex-col">
                <div>
                  <NotificationEmpty />
                </div>
                <div className="font-bold text-lg mt-4">
                  {t("noNotifications")}
                </div>
                <div className="text-xs mt-1">{t("thereIsNoNotification")}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="text-center font-bold border-t border-socialGray py-4">
        <p className="text-primary cursor-pointer" onClick={pushNotification}>
          {t("viewAllNotification")}
        </p>
      </div>
    </div>
  );
}
